import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "./Actions/userActions";
import { removeFromCart } from "./Actions/userActions";
import { useCallback } from "react";
const vendor = "37cfbaa0cdd335e81abd4aba05c5e254";

let newProduct;
const useAddtoCart = () => {
  const dispatch = useDispatch();
  // ===========remove item==============================
  const removeItem = useCallback(
    (product) => {
      let free = 0;

      dispatch(
        removeFromCart({
          vendorId: vendor,
          pID: product.pID,
          sp: product.sp,
          pName: product.newProductName,
          finalSp: product.sp,
          mrp: product.mrp,
          free_item: product?.free_item ? product?.free_item_name : null,
          free: free || 0,
          productImg: product.productImg,
          subCat: product?.subCat,
        })
      );
    },
    [removeFromCart]
  );
  // ===========add item==============================
  const addItem = useCallback(
    (product) => {
      newProduct = product;
      let free = 0;
      if (product?.buy_N_get_M) {
        free = Math.floor(1 / product?.buy_N) * product?.get_M;
      }

      dispatch(
        addToCart({
          vendorId: vendor,
          pID: product.pID,
          sp: product.sp,
          pName: product.newProductName,
          finalSp: product.sp,
          mrp: product.mrp,
          free_item: product?.free_item ? product?.free_item_name : null,
          free: free || 0,
          productImg: product.productImg || product.imageURL,
          subCat: product?.subCat,
          // productSize: product.newProductSize,
        })
      );
    },
    [addToCart]
  );

  const cart = useSelector(
    (state) => state.user.cart?.filter((c) => c.vendorId === vendor)?.[0]?.cart
  );

  return { cart, addItem, product: newProduct, removeItem };
};
export default useAddtoCart;
